import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Phone, MapPin } from "lucide-react";
import { assets, CONTACT } from "@/lib/assets";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Experience", to: "/team" },
  { label: "Contact", to: "/contact" },
];

const SOCIAL = [
  { icon: Facebook, href: CONTACT.social.facebook, label: "Facebook" },
  { icon: Instagram, href: CONTACT.social.instagram, label: "Instagram" },
  { icon: Linkedin, href: CONTACT.social.linkedin, label: "LinkedIn" },
];

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-charcoal text-white grain overflow-hidden">
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src={assets.logoWhite} alt="AGE-T" className="h-12 w-auto mb-6" />
          <p className="text-white/60 text-base leading-relaxed max-w-sm">
            Accounting services and financial advice with a personalized approach — so you gain
            peace of mind and more time for your business.
          </p>
          <div className="flex items-center gap-3 mt-8">
            {SOCIAL.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="grid place-items-center h-11 w-11 rounded-full border border-white/15 text-white/70 transition-[transform,color,border-color,background-color] duration-300 hover:-translate-y-1 hover:text-navy-900 hover:bg-emerald-brand hover:border-emerald-brand"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-sm uppercase tracking-[0.2em] text-emerald-brand mb-5">Explore</h4>
          <ul className="space-y-3">
            {NAV.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  data-testid={`footer-link-${item.label.toLowerCase()}`}
                  className="text-white/70 hover:text-white transition-colors duration-300"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-heading text-sm uppercase tracking-[0.2em] text-emerald-brand mb-5">Get in Touch</h4>
          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="footer-phone"
            className="flex items-center gap-3 text-white/70 hover:text-white transition-colors duration-300"
          >
            <Phone size={17} className="text-emerald-brand" /> {CONTACT.phoneDisplay}
          </a>
          <p className="flex items-center gap-3 text-white/70 mt-3">
            <MapPin size={17} className="text-emerald-brand" /> {CONTACT.address}
          </p>
          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="footer-cta"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-emerald-brand px-6 py-3 text-sm font-semibold text-navy-900 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_24px_-8px_rgba(16,185,129,0.5)]"
          >
            <Phone size={16} strokeWidth={2.5} /> Get in Touch
          </a>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-white/40 text-sm">© Age-T Management Consulting — All Rights Reserved</p>
        <p className="text-white/30 text-xs tracking-wide">Opal 52, Noord, Aruba</p>
      </div>
    </div>
  </footer>
);
